/** @format */

import React from "react";
import Header from "../Components/Header";
import { Outlet } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Box } from "@mui/material";

const Home = () => {
  return (
    <>
      <Header />
      <Box
        component="section"
        sx={{
          minHeight: "89vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: 'column',
        }}
      >
        <Outlet />
      </Box>
      <ToastContainer />
    </>
  );
};

export default Home;
